module.exports = __webpack_public_path__ + "static/media/bgpdf.357bbcc1.jpg";